 <mat-card>
    <mat-toolbar>
    {{'oportunitats.titol' | translate }}
    <span class="fill-remaining-space"></span>
    <div style="width:100%;float:right">
      <button mat-icon-button matTooltip="{{'oportunitats.exportToolTip' | translate}}" attr.aria-label="{{'oportunitats.exportToolTip' | translate}}" 
        matTooltipClass="tooltip-style" (click)="exportar()" style="float: right; margin-right: 0">
          <mat-icon color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
      </button>
      <button mat-icon-button style="float: right; width:70px; margin-right: 0" mat-icon-button (click)="addOportunitat()" matTooltip="{{'oportunitats.nova' | translate}}" attr.aria-label="{{'oportunitats.nova' | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">add</mat-icon>
      </button>
      <button mat-icon-button matTooltip="{{'oportunitats.filtre' | translate}}"  attr.aria-label="{{'oportunitats.filtre' | translate}}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
      </button>
    </div> 
  </mat-toolbar>
   <mcrit-gestio-oportunitats-filters
     *ngIf="showFilters"
     [validFilters]="oportunitatsFilters"
     (changeFilter)="computeActiveFilters($event)">
   </mcrit-gestio-oportunitats-filters>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
    <mat-card style="padding: 24px;width:100%">
    <table style="padding-top:40px;width:100%;table-layout: fixed">
      <thead mat-head>
        <tr>
          <th style="width:5%;text-align: center" (click)="cycleOrdering('estat')" mat-column>{{'oportunitats.colEstat' | translate}}</th>
          <th style="width:20%;text-align: center" (click)="cycleOrdering('titol')">{{'oportunitats.colTitol' | translate}}</th>
          <th style="width:6%;text-align: center" (click)="cycleOrdering('tipus')" mat-column>{{'oportunitats.colTipus' | translate}}</th>
          <th style="width:10%;text-align: center" (click)="cycleOrdering('clients')" mat-column>{{'oportunitats.colClients' | translate}}</th>
          <th style="width:11%;text-align: center" (click)="cycleOrdering('observacions')" mat-column>{{'oportunitats.colObs' | translate}}</th>
          <th style="width:2%;text-align: center" (click)="cycleOrdering('url')" mat-column>{{'oportunitats.colLink' | translate}}</th>
          <th style="width:4%;text-align: center" (click)="cycleOrdering('prioritat')" mat-column>{{'oportunitats.colPrioritat' | translate}}</th>
          <th style="width:5%;text-align: center" (click)="cycleOrdering('participacio')" mat-column>{{'oportunitats.colParticipacio' | translate}}</th>
          <th style="width:10%;text-align: right" (click)="cycleOrdering('data_limit_presentacio')" >{{'oportunitats.colDataLim' | translate}}</th>
          <th style="width:8%;text-align: right">{{'oportunitats.colpressupost' | translate}}</th>
          <th style="width:8%;text-align: left">{{'oportunitats.colCoord' | translate}}</th>
          <th style="width:8%;text-align: left">{{'oportunitats.colSuport' | translate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="oportunitatsData">
        <tr *ngFor="let dades of oportunitatsData; let i = index" style="cursor:pointer">
          <td style="width:5%;text-align:left" (click)="this.editOportunitat(dades)">
            {{ dades.estat ? ('oportunitats.dialeg.estats.' + dades.estat | translate) : '' }}
          </td>
          <td style="width:20%;text-align:left" (click)="this.editOportunitat(dades)">
              <div *ngIf="dades.ambit=='Europa'" style='color:#0000FF;font-size:1em'>{{dades.titol}}</div>
              <div *ngIf="dades.ambit=='Internacional'" style='color:#008800;font-size:1em'>{{dades.titol}}</div>
              <div *ngIf="dades.ambit=='Catalunya'" style="color:rgb(100,100,100);font-size:1em">{{dades.titol}}</div>
              <div *ngIf="dades.ambit=='Espanya'" style="color:#800000;font-size:1em">{{dades.titol}}</div>
          </td>
          <td style="width:10%;text-align:center" (click)="this.editOportunitat(dades)">
            {{dades.tipus}}
          </td>
          <td style="width:10%;text-align:center" (click)="this.editOportunitat(dades)">
            {{dades.socis_possibles}}
          </td>
          <td style="width:11%;text-align:center;word-wrap:break-word;white-space:normal" (click)="this.editOportunitat(dades)">
            <div style="width:100%">{{ dades.observacions ? (dades.observacions.length > 150 ? (dades.observacions | slice:0:150) + '...' : dades.observacions) : '' }}
            </div>
          </td>
          <td style="width:2%;text-align:left">
            <a *ngIf="dades.url" href="{{dades.url}}" style="color:#3f51b5" target="_blank"><mat-icon>cloud_circle</mat-icon></a>
          </td>
          <td style="width:2%;text-align:center" title="Prioritat {{dades.prioritat}}">
            {{dades.prioritat}}
          </td>
          <td style="width:2%;text-align:left">
            {{dades.participacio}}
          </td>
          <td style="width:10%;text-align:right" (click)="this.editOportunitat(dades)">
            {{dades.data_limit_presentacio}}
          </td>
          <td style="width:10%;text-align:right" (click)="this.editOportunitat(dades)">
            {{dades.pressupost | number:'1.0-2'}}
          </td>
          <td style="width:10%;text-align:left" (click)="this.editOportunitat(dades)">
            {{dades.coordinador}}
          </td>
          <td style="width:8%;text-align:left" (click)="this.editOportunitat(dades)">
            {{dades.tecnic_suport}}
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{'oportunitats.liniesPag' | translate}}: {{listOportunitatsService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em">
      {{'oportunitats.pagina' | translate}}:
    </span>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span style="text-align:center;width:20px">{{listOportunitatsService.currentPage+1}}</span>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
 <mat-menu #menuNumberRows y-position="above">
     <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
 </mat-menu>
</mat-card>
